export * from './detail-card.component';
export * from './detail-card.module';
